import React from 'react';
import { PhotoPlaceholder } from './Placeholders';
export function Visitanos() {
  return <section id="visitanos" className="tex-crema py-12 md:py-24 px-6 md:px-12" data-id="element-165">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-24 items-center" data-id="element-166">
        <div className="hidden md:block" data-id="element-167">
          <img src="https://cdn.magicpatterns.com/uploads/ruUyiNbFwLaE3MDGxo1zUs/esquina_Lloqe.png" alt="Esquina del taller Lloq'e en Purmamarca con el Cerro de los Siete Colores al fondo" className="w-full aspect-[4/3] md:aspect-[3/4] object-cover" data-id="element-168" />
        </div>

        <div className="flex flex-col justify-center items-start" data-id="element-169">
          <h2 className="font-labrada font-bold text-4xl md:text-5xl text-negro mb-8 leading-tight" data-id="element-170">
            Vení al Lloq'e
          </h2>
          <p className="font-labrada text-lg md:text-xl text-negro leading-relaxed mb-10" data-id="element-171">
            Encontranos en Purmamarca, en el corazón de la Quebrada de
            Humahuaca, Jujuy. Vení a vernos tejer, conocer la historia y
            llevarte una pieza única hecha con fibras 100% naturales.
          </p>
          <a href="#" className="bg-marron text-crema font-labrada px-8 py-4 rounded-sm hover:opacity-90 transition-opacity text-lg inline-block" data-id="element-172">
            Escribinos por WhatsApp
          </a>
        </div>
      </div>
    </section>;
}